/**
 * Auth Api
 * Auth Xpo Api which handles all the api restful calls
 *
 * OpenAPI spec version: v3.0.1.0
 * Contact: ea@xpo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { ApplicationSite } from '../model/applicationSite';
import { ApplicationSiteRequest } from '../model/applicationSiteRequest';
import { ValidationResult } from '../model/validationResult';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ApplicationSitesService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Applications - Delete ApplicationSite
     * This is for deleting an ApplicationSite                Sample request:                DELETE /applications/{appId}/sites/{appSiteId}
     * @param appId The Application id.
     * @param appSiteId The Application site id.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public applicationsAppIdSitesAppSiteIdDelete(appId: string, appSiteId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public applicationsAppIdSitesAppSiteIdDelete(appId: string, appSiteId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public applicationsAppIdSitesAppSiteIdDelete(appId: string, appSiteId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public applicationsAppIdSitesAppSiteIdDelete(appId: string, appSiteId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling applicationsAppIdSitesAppSiteIdDelete.');
        }
        if (appSiteId === null || appSiteId === undefined) {
            throw new Error('Required parameter appSiteId was null or undefined when calling applicationsAppIdSitesAppSiteIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.configuration.basePath}/applications/${encodeURIComponent(String(appId))}/sites/${encodeURIComponent(String(appSiteId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Applications - Update ApplicationSite
     * This is for updating an ApplicationSite                Sample request:                PUT /applications/{appId}/sites/{appSiteId}                {                    \&quot;Uri\&quot;: \&quot;http://application.xpo.com\&quot;,                    \&quot;IsLogout\&quot;: false,                    \&quot;Description\&quot;: \&quot;sample\&quot;,                    \&quot;Description\&quot;: null,                    \&quot;CreateAuthSites\&quot;: true                }
     * @param appId The Application id.
     * @param appSiteId The Application site id.
     * @param applicationSiteRequest The Site Request.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public applicationsAppIdSitesAppSiteIdPut(appId: string, appSiteId: string, applicationSiteRequest?: ApplicationSiteRequest, observe?: 'body', reportProgress?: boolean): Observable<ApplicationSite>;
    public applicationsAppIdSitesAppSiteIdPut(appId: string, appSiteId: string, applicationSiteRequest?: ApplicationSiteRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApplicationSite>>;
    public applicationsAppIdSitesAppSiteIdPut(appId: string, appSiteId: string, applicationSiteRequest?: ApplicationSiteRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApplicationSite>>;
    public applicationsAppIdSitesAppSiteIdPut(appId: string, appSiteId: string, applicationSiteRequest?: ApplicationSiteRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling applicationsAppIdSitesAppSiteIdPut.');
        }
        if (appSiteId === null || appSiteId === undefined) {
            throw new Error('Required parameter appSiteId was null or undefined when calling applicationsAppIdSitesAppSiteIdPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<ApplicationSite>(`${this.configuration.basePath}/applications/${encodeURIComponent(String(appId))}/sites/${encodeURIComponent(String(appSiteId))}`,
            applicationSiteRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Applications - Create ApplicationSite
     * This is for creating a new ApplicationSite                Sample request:                POST /applications/{appId}/sites                {                    \&quot;Uri\&quot;: \&quot;http://application.xpo.com\&quot;,                    \&quot;IsLogout\&quot;: false,                    \&quot;Description\&quot;: \&quot;sample\&quot;,                    \&quot;Description\&quot;: null,                    \&quot;CreateAuthSites\&quot;: true                }
     * @param appId The Application id.
     * @param applicationSiteRequest The Site Request.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public applicationsAppIdSitesPost(appId: string, applicationSiteRequest?: ApplicationSiteRequest, observe?: 'body', reportProgress?: boolean): Observable<ApplicationSite>;
    public applicationsAppIdSitesPost(appId: string, applicationSiteRequest?: ApplicationSiteRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApplicationSite>>;
    public applicationsAppIdSitesPost(appId: string, applicationSiteRequest?: ApplicationSiteRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApplicationSite>>;
    public applicationsAppIdSitesPost(appId: string, applicationSiteRequest?: ApplicationSiteRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (appId === null || appId === undefined) {
            throw new Error('Required parameter appId was null or undefined when calling applicationsAppIdSitesPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApplicationSite>(`${this.configuration.basePath}/applications/${encodeURIComponent(String(appId))}/sites`,
            applicationSiteRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}



// WEBPACK FOOTER //
// /ng-app/src/apiModule/api/applicationSites.service.ts